// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import ElementUI from 'element-ui'
import '../static/theme/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import VueTimers from 'vue-timers'
import VueGoodTable from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import XlsxPopulate from 'xlsx-populate'
import jsPDF from 'jspdf'
// eslint-disable-next-line
import autoTable from 'jspdf-autotable'
import VueScrollTo from 'vue-scrollto'

Vue.config.productionTip = false

// Firestore
Vue.use(VueFire)

firebase.initializeApp({
  apiKey: 'AIzaSyCGKONhXPMpPyXayt56NxWRC4NH7Q63yew',
  authDomain: 't2-project-manager.firebaseapp.com',
  databaseURL: 'https://t2-project-manager.firebaseio.com',
  projectId: 't2-project-manager',
  storageBucket: '',
  messagingSenderId: '973831944231'
})
export const db = firebase.firestore()

const settings = {timestampsInSnapshots: true}
db.settings(settings)

// Element UI
Vue.use(ElementUI, { locale })

// Vue Timers
Vue.use(VueTimers)

// vue good table  https://xaksis.github.io/vue-good-table/
Vue.use(VueGoodTable)

// vue scroll to
Vue.use(VueScrollTo)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

export const xp = XlsxPopulate

// eslint-disable-next-line
// export var JSPDF = new jsPDF({
//   orientation: 'portrait',
//   unit: 'pt',
//   format: 'letter'
// })

export const JSPDF = jsPDF



// WEBPACK FOOTER //
// ./src/main.js